import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

/**
 * 판매기간 contents
 * - dd HH:mm:ss
 */
function Period({ day, hour, minutes, seconds }) {
  return (
    <div className="info_unit_contents">
      <p>
        <strong>
          {day !== 0 ? <Fragment>{day}일 </Fragment> : ''}
          {hour < 10 ? <Fragment>0{hour}</Fragment> : hour}:
          {minutes < 10 ? <Fragment>0{minutes}</Fragment> : minutes}:
          {seconds < 10 ? <Fragment>0{seconds}</Fragment> : seconds}
        </strong>{' '}
        남음
      </p>
    </div>
  );
}

Period.propTypes = {
  day: PropTypes.number.isRequired,
  hour: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  seconds: PropTypes.number.isRequired,
};

export default Period;
